import {
    useParams
  } from "react-router-dom";

function Artist() {
    let { artistName } = useParams();
     return(
      <h1>{artistName}</h1>
     )
  }
export default Artist;